/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

/* components */
import NavItem from "./NavItem";
import SidebarTitle from "./SidebarTitle";
import SidebarSection from "./SidebarSection";
import UserHasPermission from "../../helpers/validation/userHasPermission";

class ExperienceNav extends Component {
	constructor(props) {
		super(props);
		this.state = {
			show: false,
			chatPageConfigs: {},
		};
	}

	componentDidMount() {
		const { match, pagesActions } = this.props;
		const { expId } = match.params;
		pagesActions.loadPages(expId);
		setTimeout(() => {
			this.setState({ show: true });
		}, 300);
	}

	shouldComponentUpdate(nextProps) {
		const { match, pagesActions, pages } = this.props;
		let { expId } = match.params;
		let newExpId = nextProps.match.params.expId;
		if (expId !== newExpId) {
			pagesActions.loadPages(newExpId);
		}
		return true;
	}

	reloadPages = () => {
		const { match, pagesActions } = this.props;
		let { expId } = match.params;
		pagesActions.loadPages(expId);
	};

	deletePage = (id, name) => {
		if (id === this.props.match.params.pageId) {
			const { appKey, expId } = this.props.match.params;
			this.props.globalActions.deleteItem(
				"/pages/" + id,
				() => {
					this.props.history.push(`/apps/${appKey}/experiences/${expId}/pages`);
					this.reloadPages();
				},
				this.logError,
				name
			);
		} else {
			this.props.globalActions.deleteItem("/pages/" + id, this.reloadPages, this.logError, name);
		}
	};

	render() {
		const { user } = this.props;
		const { appKey, expId } = this.props.match.params;
		const basePath = `/apps/${appKey}/experiences`;
		const { pages, chatPages } = this.props.pages;
		const { show } = this.state;

		const chatChannels = [];

		Object.keys(chatPages).forEach(chatPageId => {
			chatPages[chatPageId].properties.channels.forEach(channel => {
				if (!chatChannels.find(c => c.id === channel.id)) {
					chatChannels.push({ id: channel.id, name: channel.name });
				}
			});
		});

		const userIsStructure = UserHasPermission(user, "structure");

		const pollPages = Object.values(pages || {}).filter(page => page.moduleName === "Polls");

		return (
			<div className={`animate animate-show${show ? " animated" : ""}`}>
				<SidebarTitle to={`/apps/${appKey}`} title="My App" />
				<SidebarSection
					to={userIsStructure ? `${basePath}/${expId}/pages/new` : null}
					title="Pages"
					items={pages}
					itemPath={`${basePath}/${expId}/pages`}
					activeId={this.props.match.params.pageId}
					showOptions={userIsStructure}
					deleteItem={userIsStructure ? this.deletePage : null}
				/>
				{/*
					<SidebarSection title="Settings" />
					*/}
				{userIsStructure && <SidebarSection gridPath={`${basePath}/${expId}/navigation`} title="Navigation" />}
				{chatChannels.length > 0 && (
					<SidebarSection title="Chat">
						{chatChannels.map(chatChannel => (
							<NavItem
								key={chatChannel.id}
								linkTo={`${basePath}/${expId}/chat/${chatChannel.id}`}
								text={chatChannel.name}
							/>
						))}
					</SidebarSection>
				)}

				{pollPages.length > 0 && (
					<SidebarSection title="Voting/Poll Results">
						{pollPages.map(pollPage => (
							<NavItem
								key={pollPage.id}
								linkTo={`${basePath}/${expId}/polls/${pollPage.id}`}
								text={pollPage.name}
							/>
						))}
					</SidebarSection>
				)}
			</div>
		);
	}
}
ExperienceNav.propTypes = {
	pagesActions: PropTypes.object,
	pages: PropTypes.object,
	match: PropTypes.object,
	globalActions: PropTypes.object,
	history: PropTypes.array,
	user: PropTypes.object,
};
export default ExperienceNav;
